import React from 'react';
import { downloadFileS3 } from '../../helpers/s3';
import styled from 'styled-components';

interface Props {
  path?: string;
  filename_original: string;
  className?: string;
}

const UploadFilename: React.FC<Props> = ({ path, filename_original, className }) => {
  const split = filename_original.split('.');
  let extension;

  if (split.length) {
    extension = split[split.length - 1];
    switch (extension) {
      case 'docx':
      case 'docm':
      case 'pptx':
        extension = extension.substring(0, extension.length - 1); /* Remove 'x' letter */
        break;
    }
  } else {
    extension = '';
  }

  return (
    <div
      className={`${className} ${path ? 'cursor-pointer flex items-center text-black' : ''}`}
      onClick={path ? () => downloadFileS3(path, filename_original) : undefined}
    >
      {extension && <span className={`k-icon k-i-file-${extension}`}></span>}
      <span>{filename_original}</span>
    </div>
  );
};

const StyledUploadFilename = styled(UploadFilename)`
  .k-icon {
    padding-right: 0.4rem;
    color: #000000;
  }
`;

export default StyledUploadFilename;
